module.exports = __webpack_public_path__ + "static/media/be-BY.ade5e3a3.md";